import { useCallback, useEffect, useState } from "react";

import { authStateFromToken, clearAuth, getAuth, setAuth, type AuthState } from "../../lib/auth";

const SUBSCRIBERS = new Set<() => void>();

function notifyAll(): void {
  for (const fn of SUBSCRIBERS) fn();
}

export function useAuth() {
  const [state, setState] = useState<AuthState | null>(() => getAuth());

  useEffect(() => {
    const sync = () => setState(getAuth());

    SUBSCRIBERS.add(sync);
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);

    return () => {
      SUBSCRIBERS.delete(sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);

  const login = useCallback((accessToken: string) => {
    const next = authStateFromToken(accessToken);
    setAuth(next);
    setState(next);
    notifyAll();
  }, []);

  const logout = useCallback(() => {
    clearAuth();
    setState(null);
    notifyAll();
  }, []);

  return { state, login, logout, isAuthenticated: state !== null };
}
